// React
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { MinimalHeader, Menu } from '@mobilitystore/components-interface';
import DeviceBreakPoints from '../../../deviceBreakPoints';
import MenuPopup from '../menu-popup';

// Data
import { uspLandingMenu } from '../data';

// Assets
import images from '../../../assets/img';

// Utils
import { getDeviceClass } from '../../../utils';

// Css
import './index.scss';

const UspMarketingHeader = ({ handleMenuClick, handleGetInTouchClick }) => {
  const { isDesktopDevice, isXlDevice } = DeviceBreakPoints();

  const { content } = useSelector((state) => ({
    content: state.ContentReducer.content
  }));
  const deviceClass = getDeviceClass();

  const [popupOpen, setPopupOpen] = useState(false);
  const history = useHistory();

  const handleButtonClick = () => {
    history.push('/login');
  };
  const minimalHeaderDesktopContent = {
    images: {
      logo: {
        image: images.boschLogo,
        alt: content?.components?.header?.images?.logo?.alt
      }
    },
    buttons: [
      {
        id: 101,
        type: 'Button',
        mode: 'primary',
        label: content?.components?.landing?.login,
        className: 'usp-minimal-header__login',
        onClick: handleButtonClick
      },
      {
        id: 102,
        type: 'Button',
        mode: 'secondary',
        label: content?.components?.landing?.get_in_touch,
        className: 'usp-minimal-header__get_in_touch',
        onClick: handleGetInTouchClick
      }
    ]
  };

  const minimalHeaderMobileContent = {
    images: {
      logo: {
        image: images.boschLogo,
        alt: content?.components?.header?.images?.logo?.alt
      }
    },
    buttons: [
      {
        id: 101,
        type: 'Link',
        label: content?.components?.landing?.login,
        icon: 'a-icon boschicon-bosch-ic-login',
        className: 'usp-minimal-header__login',
        onClick: handleButtonClick
      },
      {
        id: 102,
        type: 'Link',
        label: content?.components?.landing?.get_in_touch,
        icon: 'a-icon boschicon-bosch-ic-message',
        className: 'usp-minimal-header__get_in_touch',
        onClick: handleGetInTouchClick
      }
    ]
  };

  return (
    <div>
      <div className={`usp-header ${deviceClass}`}>
        {isDesktopDevice || isXlDevice ? (
          <>
            <MinimalHeader
              className='usp-minimal-header'
              align='left'
              isLoggedIn={true}
              logo={minimalHeaderDesktopContent?.images?.logo}
              links={minimalHeaderDesktopContent.buttons}
              onLogoClick={() => (window.location.href = '/')}
            />
            <div className='usp-header-menu-container'>
              <Menu
                className='usp-header-menu-container__menu'
                heading={uspLandingMenu}
                handleMenuClick={handleMenuClick}
              />
              <span className='usp-header-text-container__text'>
                {content?.name}
              </span>
            </div>
          </>
        ) : (
          <div>
            <MinimalHeader
              className='usp-minimal-header'
              align='left'
              logo={minimalHeaderMobileContent?.images?.logo}
              links={minimalHeaderMobileContent.buttons}
            />
            <div className='usp-header-menu-container'>
              <div className='usp-header-menu-container__icon'>
                <i
                  className='a-icon ui-ic-menu'
                  onClick={() => setPopupOpen(true)}
                  tabIndex={0}
                  role='button'
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ')
                      setPopupOpen(true);
                  }}
                ></i>
              </div>
              <div className='usp-header-text-container'>
                <span className='usp-header-text-container__text'>
                  {content?.name}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <MenuPopup
        menuItems={uspLandingMenu}
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        handleMenuClick={handleMenuClick}
      />
    </div>
  );
};

export default UspMarketingHeader;
